import Vue from "vue";
import VueI18n from "vue-i18n";
import VueI18nFilter from "vue-i18n-filter";
import VueProgressBar from "vue-progressbar";
import VueConfetti from "vue-confetti";

import * as Sentry from "@sentry/vue";

import VueMoment from "vue-moment";
import moment from "moment";

// Only import the plugins we are actually using, which allows for smaller bundles
// (cf. https://bootstrap-vue.js.org/docs#tree-shaking-with-module-bundlers)
//
import {
    DropdownPlugin,
    SidebarPlugin,
    SpinnerPlugin,
    VBPopoverPlugin,
    VBTooltipPlugin,
} from "bootstrap-vue";

import App from "@/App.vue";

import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";
import "./assets/tailwind.css";

Vue.config.productionTip = false;

// Sentry
Sentry.init({
    Vue: Vue,
    release: `leapsome-client@${process.env.VUE_APP_RELEASE_TAG ?? "unspecified-version"}`,
    logErrors: true,
    dsn: "https://99adf37a045f4308b84891b91574fd52@o309874.ingest.sentry.io/1774569",
    environment: window.location.href.startsWith("https://www.leapsome.com/")
        ? "production"
        : window.location.href.startsWith("https://staging.leapabit.com/")
        ? "staging"
        : "local",
});

// i18n
Vue.use(VueI18n);
Vue.use(VueI18nFilter);
Vue.use(VueMoment, { moment });

// Bootstrap
Vue.use(DropdownPlugin);
Vue.use(SidebarPlugin);
Vue.use(SpinnerPlugin);
Vue.use(VBPopoverPlugin);
Vue.use(VBTooltipPlugin);

// Global progress bar
Vue.use(VueProgressBar, {
    color: "white",
    failedColor: "red",
    height: "1px",
});

// Confetti 🎉🎊🥳
Vue.use(VueConfetti);

// Development utilities
//
if (process.env.NODE_ENV === "development") {
    // Alias `console.log` to `$log` to be used in templates.
    // eslint-disable-next-line no-console
    Vue.prototype.$log = console.log;
} else {
    // Reset `$log` to a no-op function
    Vue.prototype.$log = () => {};
}

// Mount!
new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount("#app");
